export class LocalFilter {
  public static filter(
    data: any[],
    field: string,
    search: string,
    customFilter?
  ): any[] {
    const filter = customFilter ? customFilter : this.FILTER;

    return data.filter((el) => {
      const value =
        typeof el[field] === 'undefined' || el[field] === null ? '' : el[field];
      return filter.call(null, value, search);
    });
  }

  protected static FILTER = (value: string, search: string) => {
    return value
      .toString()
      .toLowerCase()
      .includes(search.toString().toLowerCase());
  }
}
